import { useMemo } from 'react';
import ChestReceivedRewardBg from '../../../../assets/images/chests/rewards/chest-received-reward-bg.png';
import { useAppSelector } from '../../../../store';
import ReceivedChestReward from '../../../../templates/ReceivedChestReward';
import { TChestRewardHistory } from '../../../../types';
import { getShineBg } from '../../utils/getShineBg';

type TCollectChestRewardProps = {
  reward: TChestRewardHistory | undefined
  onCollect: () => void;
}

function CollectChestReward({ onCollect, reward }: TCollectChestRewardProps) {
  const { chestsList } = useAppSelector(({ chests }) => chests);

  const chest = useMemo(() => chestsList.find((c) => c.id === reward?.chest_id), [reward, chestsList]);

  const shine = getShineBg(chest?.variant ?? 'launch');

  return (
    <div className={`${reward ? '' : 'hidden'} absolute inset-0 w-full h-full z-[100] pt-[96px]`}>
      <img src={ChestReceivedRewardBg} alt="chest-received-reward" className="absolute w-full h-full inset-0 object-cover z-[-1]" />
      <img src={shine} alt="shine" className="absolute inset-0 top-[50px] z-[-1] h-full opacity-[0.6]" />
      {reward
      && <ReceivedChestReward onCollect={onCollect} reward={reward} />}
    </div>
  );
}

export default CollectChestReward;
